import { createBrowserHistory } from 'history'
import { RouterStore} from '@superwf/mobx-react-router'

const browserHistory = createBrowserHistory();
/*const browserHistory = createBrowserHistory({
    basename: process.env.REACT_APP_BASENAME
  });
  */
const routing = new RouterStore(browserHistory);
 export default routing;
/*
import { RouterStore } from 'mobx-react-router';

const routingStore = new RouterStore();

export default routingStore;
*/